<template>
  <div class="box">
    <div class="btns">
      <el-button :class="{ active: currenIndex === 0 }" style="background: #3f8cf9" size="mini"
        @click="yesterday(0)">昨天</el-button>
      <el-button :class="{ active: currenIndex === 1 }" style="background: #f9888d" size="mini"
        @click="today(1)">当天</el-button>
      <el-button :class="{ active: currenIndex === 2 }" style="background: #f3b154" size="mini"
        @click="toweek(2)">当周</el-button>
      <el-button :class="{ active: currenIndex === 3 }" style="background: #27d3a5" size="mini"
        @click="tomonth(3)">当月</el-button>
      <el-button style="background: #faf" size="mini" @click="back">返回</el-button>
    </div>
    <div class="middle">
      <div class="title">
        <h1>生产和检查情况</h1>
      </div>
      <div class="p">
        <p>挡车工：{{ user.PersonName }}</p>
        <p>累计报工纬数:{{ list.SumWorkWeft }}</p>
        <p>累计米数：{{ list.SumWorkNumber }}</p>
        <p>累计卷数：{{ list.SumRollNum }}</p>
        <p>半成品检验合格米数：{{ list.SumCheckNumber }}</p>
        <p>缺陷米数：{{ list.SumDefectNumber }}</p>
        <p>未检米数：{{ list.SumUnCheckNumber }}</p>
        <p>扣分情况：{{ list.SumDeduction }}</p>
      </div>
    </div>

    <div class="tab">
      <div class="title">
        <h1>报工明细</h1>
      </div>
      <el-table border :data="list.PLSWeavWorks" stripe height="275" size="mini" width="100%">
        <el-table-column prop="SERIALNO" label="流水号"> </el-table-column>
        <el-table-column prop="PRODUCTID" label="产品型号"> </el-table-column>
        <el-table-column prop="WorkWeft" label="纬数"></el-table-column>
        <el-table-column prop="WorkNumber" label="报工米数"></el-table-column>
        <el-table-column prop="CheckNumber" label="检验米数"></el-table-column>
        <el-table-column prop="DEFECTLENGTH" label="缺陷米数"></el-table-column>
        <el-table-column prop="SUBTRACTNUM" label="扣分"></el-table-column>
        <el-table-column prop="datatime" label="日期"> </el-table-column>
      </el-table>
    </div>
    <div class="tab1">
      <div class="title">
        <h1>机台汇总</h1>
      </div>
      <el-table border :data="list.PLSWeavWorksTotal" stripe height="207" size="mini">
        <el-table-column prop="MACHINEID" label="机台号"> </el-table-column>
        <el-table-column prop="WorkWeft" label="纬数"> </el-table-column>
        <el-table-column prop="WorkNumber" label="报工总米数"></el-table-column>
        <el-table-column prop="CheckNumber" label="检验总米数"></el-table-column>
        <el-table-column prop="DEFECTLENGTH" label="缺陷米数"></el-table-column>
        <el-table-column prop="SUBTRACTNUM" label="扣分"></el-table-column>
        <el-table-column prop="datatime" label="日期"> </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { api } from "../../api";
import localStorage from "../../api/localStorage";
export default {
  name: "reportFiber",
  data() {
    return {
      currenIndex: 1,
      list: {},
      user: localStorage.getUser(),
      weekArr: [],
      monthArr: [],
      show: false,
      startTime: this.dayjs().format("YYYY-MM-DD") + " 00:00:00",
      endTime: this.dayjs().format("YYYY-MM-DD") + " 23:59:59",
    };
  },
  created() {
    this.getList(this.startTime, this.endTime);
  },
  methods: {
    getList(startTime, endTime) {
      let params = {
        UserID: this.user.UserId,
        StartDate: startTime,
        EndDate: endTime,
      };
      console.log(params);
      api.GetZZWorkRpt(this.$qs.stringify(params)).then((res) => {
        console.log(res.data);
        this.list = res.data;
        this.list.PLSWeavWorks.forEach((item) => {
          if (item.BILLDATE != 0) {
            item.BILLDATE = item.BILLDATE + "";
            var year = item.BILLDATE.slice(0, 4);
            var month = item.BILLDATE.slice(4, 6);
            var date = item.BILLDATE.slice(6, 8);
            var datatime = year + "-" + month + "-" + date;
            this.$set(item, "datatime", datatime);
          }
          if (item.BILLDATE == 0) {
            this.$set(item, "datatime", item.BILLDATE);
          }
        });
        if (this.list.PLSWeavWorksTotal !== null) {
          this.list.PLSWeavWorksTotal.forEach((item) => {
            if (item.BILLDATE != 0) {
              item.BILLDATE = item.BILLDATE + "";
              var year = item.BILLDATE.slice(0, 4);
              var month = item.BILLDATE.slice(4, 6);
              var date = item.BILLDATE.slice(6, 8);
              var datatime = year + "-" + month + "-" + date;
              this.$set(item, "datatime", datatime);
            }
            if (item.BILLDATE == 0) {
              this.$set(item, "datatime", item.BILLDATE);
            }
          });
        }
      });
    },
    // 当天
    today(index) {
      this.currenIndex = index;
      const startTime = this.dayjs().format("YYYY-MM-DD") + " 00:00:00";
      const endTime = this.dayjs().format("YYYY-MM-DD") + " 23:59:59";
      this.getList(startTime, endTime);
    },
    yesterday(index) {
      this.currenIndex = index;
      const startTime =
        this.dayjs().subtract(1, "day").format("YYYY-MM-DD") + " 00:00:00";
      const endTime =
        this.dayjs().subtract(1, "day").format("YYYY-MM-DD") + " 23:59:59";
      this.getList(startTime, endTime);
    },
    // 获取当周天数
    toweek(index) {
      this.currenIndex = index;
      const startTime =
        this.dayjs().subtract(7, "day").format("YYYY-MM-DD") + " 23:59:59";
      const endTime = this.dayjs().format("YYYY-MM-DD") + " 00:00:00";
      this.getList(startTime, endTime);
    },
    tomonth(index) {
      // 获取当月时间
      this.currenIndex = index;
      const startTime =
        this.dayjs().startOf("month").format("YYYY-MM-DD") + " 00:00:00";
      const endTime =
        this.dayjs().endOf("month").format("YYYY-MM-DD") + " 23:59:59";
      this.getList(startTime, endTime);
    },

    back() {
      this.$router.go(-1);
    },
  },
};
</script>

<style>
.el-table {
  color: #737373;
  font-size: 8px;
  border: 1px solid #ccc;
  /* padding: 0 5px 5px 5px; */
}

.el-table .cell {
  text-align: center;
  padding: 0.01rem 0;
}

.el-table th>.cell {
  padding: 0.01rem 0;
}

.el-table__body,
.el-table__footer,
.el-table__header {
  width: 98% !important;
}

.el-table thead {
  color: #323232;
  font-weight: 100;
  font-size: 9px;
  background: #f8f8f8;
}

.el-table td,
.el-table th.is-leaf {
  border-bottom: 1px solid #d9d9d9;
  border-right: 1px solid #cecece;
  padding: 0.01rem 0;
}

.el-table td:last-child {
  border-right: 0;
}

.el-table th:last-child {
  border-right: 0;
}

.el-button {
  color: #fff !important;
}
</style>
<style scoped lang="less">
@deep: ~">>>";

.box {
  height: 100%;
  padding: 8px;
  box-sizing: border-box;
  background: #eee;
  border: 1px solid #cecece;

  .btns {
    // margin-top: 10px;
    display: flex;
    padding: 3px 5px;
    justify-content: flex-start;
    background: #fff;
    border: 1px solid #b2b2b2;

    .el-button {
      margin-right: 50px;
      font-size: 0.25rem;
    }

    .el-button--mini,
    .el-button--mini.is-round {
      padding: 0.15rem 0.4rem;
    }

    .active {
      background: #f00 !important;
      // border: 2px solid #ff6700 !important;
    }
  }

  .middle {
    .title {
      height: 0.7rem;
      line-height: 0.7rem;
    }

    .p {
      // margin-top: 10px;
      padding: 3px 5px;
      display: flex;
      justify-content: space-between;
      font-size: 0.25rem;
      height: 0.5rem;
      line-height: 0.5rem;
      background-color: #fff;
      border: 1px solid #b2b2b2;
    }
  }

  h1 {
    font-weight: bold;
    font-size: 0.28rem;
    height: 0.7rem;
    line-height: 0.7rem;
  }

  .tab,
  .tab1 {
    width: 100%;
    margin-top: 0px;

    .title {
      height: 0.7rem;
      line-height: 0.7rem;
    }

    @{deep}.el-table {
      border: 1px solid #b2b2b2;
      color: #333;

      .cell {
        text-align: center;
        padding: 0;
        // font-weight: 400;
        color: #494949;
        font-size: 0.23rem !important;
      }
    }
  }
}
</style>
